import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiPagination from '@material-ui/lab/Pagination';

const TablePaginationNavigation = ({ totalPages, currentPage, onChange }) => (
  <MuiPagination
    count={totalPages}
    page={currentPage}
    showFirstButton
    showLastButton
    onChange={(event, page) => onChange(page)}
  />
);

TablePaginationNavigation.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TablePaginationNavigation;



// WEBPACK FOOTER //
// ./components/core/table/TablePaginationNavigation.js